import { sendPersonalMeetingRoomV2, startCallV2 } from "@/modules/lead-page/api/lead-page.v2.api";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { queryClient } from "@/queryClient";
import { UUID } from "crypto";
import { useCallback, useContext, useState } from "react";
import { useMutation } from '@tanstack/react-query';

const useCopyZoomLink = () => {
  const { lead } = useContext(LeadPageContext);
  const leadId = lead?.data?.lead.journey_uid;
  const [zoomLinkModalOpen, setZoomLinkModalOpen] = useState(false);
  const [meetingTime, setMeetingTime] = useState("LATER");

  const {
    mutate: getZoomMeetingRoomMutation,
    isLoading: isGetZoomMeetingLoading,
    isSuccess,
    isError,
  } = useMutation({
    mutationFn: ({
      leadId,
      meetingTime,
    }: {
      leadId: string | number | UUID;
      meetingTime: string;
    }) => sendPersonalMeetingRoomV2(leadId, meetingTime),
    onSuccess: () => {
      // Post a "zoom call started" comment to the activity timeline
      if (leadId) {
        startCallV2(leadId, true).then(() => {
          queryClient.invalidateQueries({ queryKey: ["getComments"] });
          queryClient.invalidateQueries({ queryKey: ["lead-activity"] });
        }).catch(() => {
          // Comment creation is best-effort — don't block on failure
        });
      }
    },
  });

  const handleGetZoomLink = useCallback(() => {
    if (leadId && meetingTime) {
      getZoomMeetingRoomMutation({ leadId, meetingTime });
    }
  }, [leadId, meetingTime, getZoomMeetingRoomMutation]);

  return {
    handleGetZoomLink,
    zoomLinkModalOpen,
    setZoomLinkModalOpen,
    meetingTime,
    setMeetingTime,
    isGetZoomMeetingLoading,
    isSuccess,
    isError,
  };
};
export default useCopyZoomLink;
